<template>
  <v-row class="my-2">
    <v-col class="py-1" cols="12" sm="6" md="4" lg="3">
      <ActionCard title="Mes transactions" description="Historique de mes transactions pour cet événement"
        icon="mdi-receipt" toPage="Historique"></ActionCard>
    </v-col>
    <v-col class="py-1" cols="12" sm="6" md="4" lg="3">
      <ActionCard title="Nouvelle inscription" description="Inscrire un nouveau participant à cet événement"
        icon="mdi-account-plus" toPage="Home"></ActionCard>
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
